import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Question, QuestionCheckInput} from '@cp/model';
import {CHECK_QUESTION_WITH_RULES_DIRECT} from '../sharedQueries';

export function useCheckQuestionWithRulesDirect() {
  const [checkQuestionWithRulesDirectMutation, {loading, error}] = useMutation<
    {checkQuestionWithRulesDirect: Question},
    {questionInput: QuestionCheckInput}
  >(CHECK_QUESTION_WITH_RULES_DIRECT);

  /**
   * Check a question input using rules validation directly (Admin only)
   * @param questionInput - The question input to validate
   * @returns Question with updated status and statusNote if validation fails
   */
  const checkQuestionWithRulesDirect = async (questionInput: QuestionCheckInput) => {
    const result = await checkQuestionWithRulesDirectMutation({
      variables: {questionInput},
    });

    return extractGqlData(result).checkQuestionWithRulesDirect;
  };

  return {
    checkQuestionWithRulesDirect,
    loading,
    error,
  };
}
